// 📁 src/hooks/useCaseTitles.js
import { useState, useEffect } from "react";
import { loadCase } from "../data/loadCase";

export function useCaseTitles(max = 3) {
  const [cases, setCases] = useState([]);
  useEffect(() => {
    loadCase().then((data) => {
      setCases(data.slice(0, max));
    });
  }, [max]);
  return cases;
}